const alertConfig = {
  ALERT_TEST_TYPES: "d37d5f60-9676-11e9-8b5f-00ff12c3b408",
  LESS_THAN_OR_EQUAL_TO: "d37d5f89-9676-11e9-8b5f-00ff12c3b408",
  GREATER_THAN_OR_EQUAL_TO: "d37d5f8f-9676-11e9-8b5f-00ff12c3b408",
  ALERT_FORMAT_TYPES: "d37d5f94-9676-11e9-8b5f-00ff12c3b408",
  PERCENT: "d37d5f98-9676-11e9-8b5f-00ff12c3b408",
  NUMBER: "d37d5f9d-9676-11e9-8b5f-00ff12c3b408",
  CURRENCY: "d37d5fa2-9676-11e9-8b5f-00ff12c3b408",
  DATE: "d37d5fa6-9676-11e9-8b5f-00ff12c3b408",
  GUID: "d37d5fab-9676-11e9-8b5f-00ff12c3b408",
  BOOLEAN: "c1a30982-e711-11ea-a79f-98fa9bde2f84",
  ALERT_LEVELS: "678ae798-9693-11e9-8b5f-00ff12c3b408",
  ALERT_FOR_PORTFOLIO: "678ae72f-9693-11e9-8b5f-00ff12c3b408",
  ALERT_FOR_FUND: "678ae775-9693-11e9-8b5f-00ff12c3b408",
  ALERT_FOR_DEAL: "678ae77b-9693-11e9-8b5f-00ff12c3b408",
  ALERT_FOR_GUARANTOR: "678ae782-9693-11e9-8b5f-00ff12c3b408",
  ALERT_DATA_SOURCES: "678ae79c-9693-11e9-8b5f-00ff12c3b408",
  DATA_SOURCE_METRICS: "678ae789-9693-11e9-8b5f-00ff12c3b408",
  DATA_SOURCE_MARKET_DATA: "678ae78e-9693-11e9-8b5f-00ff12c3b408",
  DATA_SOURCE_HEDGE_INPUT: "678ae793-9693-11e9-8b5f-00ff12c3b408",
  EXTENSION_QUALIFICATION: "217840d1-e70f-11ea-a79f-98fa9bde2f84"
};

export const ALERT_TEST_TYPES_LIST = [
  { value: alertConfig.LESS_THAN_OR_EQUAL_TO, name: "Less than or equal to" },
  { value: alertConfig.GREATER_THAN_OR_EQUAL_TO, name: "Greater than or equal to" }
];
export const ALERT_FORMAT_TYPES_LIST = [
  { value: alertConfig.PERCENT, name: "Percent" },
  { value: alertConfig.NUMBER, name: "Number" },
  { value: alertConfig.CURRENCY, name: "Currency" },
  { value: alertConfig.DATE, name: "Date" },
  { value: alertConfig.GUID, name: "Guid" },
  { value: alertConfig.BOOLEAN, name: "Boolean" }
];

export const ALERT_LEVELS_LIST = [
  { value: alertConfig.ALERT_FOR_PORTFOLIO, name: "Portfolio", label: "Portfolio" },
  { value: alertConfig.ALERT_FOR_FUND, name: "Group", label: "Group" },
  { value: alertConfig.ALERT_FOR_DEAL, name: "Deal", label: "Deal" },
  { value: alertConfig.ALERT_FOR_GUARANTOR, name: "Guarantor", label: "Guarantor" }
];
export const ALERT_DATA_SOURCES_LIST = [
  { value: alertConfig.DATA_SOURCE_METRICS, name: "Metrics" },
  { value: alertConfig.DATA_SOURCE_MARKET_DATA, name: "Market Data" },
  { value: alertConfig.DATA_SOURCE_HEDGE_INPUT, name: "Hedge Input" }
];

export const ALERT_TYPES_LIST = [
  { value: "31134a3e-9699-11e9-8b5f-00ff12c3b408", name: "Prepayment Penalty" },
  { value: "31134a97-9699-11e9-8b5f-00ff12c3b408", name: "Hedge Mark-to-Market" },
  { value: "31134aa3-9699-11e9-8b5f-00ff12c3b408", name: "DSCR" },
  { value: "31134aad-9699-11e9-8b5f-00ff12c3b408", name: "Debt Yield" },
  { value: "31134ab5-9699-11e9-8b5f-00ff12c3b408", name: "LTV" },
  { value: "31134abe-9699-11e9-8b5f-00ff12c3b408", name: "Occupancy" },
  { value: "31134ac8-9699-11e9-8b5f-00ff12c3b408", name: "1M LIBOR (Spot)" },
  { value: "31134ad1-9699-11e9-8b5f-00ff12c3b408", name: "Cap Strike Hit" },
  { value: "31134ada-9699-11e9-8b5f-00ff12c3b408", name: "Hedge Counterparty Rating" },
  { value: "31134ae3-9699-11e9-8b5f-00ff12c3b408", name: "Recourse Exposure" }
];

alertConfig.PROJECTED_ALERT_TYPES_LIST = [
  { value: "31134aa3-9699-11e9-8b5f-00ff12c3b408", name: "DSCR" },
  { value: "31134aad-9699-11e9-8b5f-00ff12c3b408", name: "Debt Yield" },
  { value: "31134ab5-9699-11e9-8b5f-00ff12c3b408", name: "LTV" },
  { value: "31134abe-9699-11e9-8b5f-00ff12c3b408", name: "Occupancy" }
];

alertConfig.EXTENSION_QUALIFICATION_OPTIONS = [
  { value: "1", label: "Qualified" },
  { value: "0", label: "Not Qualified" }
];

export default alertConfig;
